import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse, WinbackCode } from '../types';

const URL = '/v2/winback-codes';

class WinbackCodeService {
  static get(id: number, config?: AxiosRequestConfig): Promise<DataResponse<WinbackCode>> {
    return axios.get(`${URL}/${id}`, config);
  }

  static getByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<WinbackCode>> {
    return axios.get(URL, config);
  }

  static patch(id: number, data: Partial<WinbackCode>, config?: AxiosRequestConfig): Promise<DataResponse<WinbackCode>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }

  static create(data: WinbackCode, config?: AxiosRequestConfig): Promise<DataResponse<WinbackCode>> {
    return axios.post(URL, data, config);
  }
}

export { WinbackCodeService };
